import { Tree as ArboristTree } from 'react-arborist'
import TreeNode from './TreeNode'
import { Stack } from '@mui/system'
import React from 'react'
import TreeRow from './TreeRow'

import _get from 'lodash/get'

const Tree = React.forwardRef(
  (
    {
      node,
      searchInput = null,
      data,
      disabled = false,
      onNodeSelect = () => { },
      disableClickOnParent = false,
      disableChildOnParentSelect = false,
      onlySite = false,
      loadingNodesIds,
      apiFold,
      padding = 8,
      ...props
    },
    ref
  ) => {
    const additionalNodeProps = nodeId => ({
      onNodesChange: props.onNodesChange,
      onParentSelect: props.onParentNodeSelect,
      onClick: props.onClick,
      onToggle: props.onToggle,
      onlySite,
      disabled,
      disableChildOnParentSelect,
      disableClickOnParent,
      loading: isNodeLoading(nodeId),
      renderCounter: props.renderCounter,
      highlightTerm: props.highlightWord,
      isMultiSelect: props.disableMultiSelection,
      checkBoxComponent: props.checkBoxComponent ?? null,
      apiFold,
    })

    const [treeHeight, setTreeHeight] = React.useState(400);
    const handleTreeRef = (treeInstance) => {
      if (treeInstance) {
        const calculatedHeight = (treeInstance.visibleNodes.length * 30) + (padding * 2);
        const newHeight = Math.min(calculatedHeight, 400);
        setTreeHeight(newHeight);
      }
      if (ref) {
        ref.current = treeInstance;
      }
    };

    const isNodeLoading = nodeId => {
      return _get(loadingNodesIds, nodeId, false) === true
    }

    return (
      <Stack
        gap={1}
        height={'100%'}
        maxHeight={420}
        mt={searchInput ? 1 : 0}>
        {searchInput}
        <ArboristTree
          {...props}
          ref={handleTreeRef}
          rowHeight={30}
          padding={padding}
          renderRow={TreeRow}
          indent={20}
          width={'100%'}
          height={treeHeight}
          data={data}
          dndRootElement={null}
          disableDrag
          disableDrop
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
          }}>

          {nodeProps =>
            node ? (
              node({ ...nodeProps, ...additionalNodeProps(nodeProps.node.id) })
            ) : (
              <TreeNode {...additionalNodeProps(nodeProps.node.id)} {...nodeProps} onSelect={onNodeSelect} />
            )
          }
        </ArboristTree>
      </Stack>
    )
  }
)

export default Tree
